module.exports = __webpack_public_path__ + "img/search-icon.8e3a6226.png";